var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReadFlags } from "../../../fnx/readFlags";
import { removeNonNumeric } from "../../../services/functions";
import LocalStorageService from "../../../services/localStorage";
import { quoteOne } from "../../../store/generateQuote/actions";
import { pageActionFlagsApi } from "../../../store/pageActionFlags/actions";
import { updatePerson } from "../../../store/person/actions";
import { region } from "../../../store/region/actions";
import { patchQuote } from "../../../store/updateQuote/actions";
import { formattedDateWithTime } from "../../../utils/date";
import { Steps } from "../../../enum/steps";
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
var useClient = function (paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance, setShowTabRealEstates, setShowFormBusiness, setShowTabAppointment, setShowTabAppointmentManager, quoteId, userId) {
    var dispatch = useDispatch();
    var storageKey = "afy-steps";
    var localStorageService = useMemo(function () { return new LocalStorageService(storageKey); }, [storageKey]);
    var t = useTranslation().t;
    var _a = React.useState(false), showVehicleData = _a[0], setShowVehicleData = _a[1];
    var _b = React.useState(false), showDownloadQuote = _b[0], setShowDownloadQuote = _b[1];
    var _c = React.useState(false), showDownloadRequest = _c[0], setShowDownloadRequest = _c[1];
    var callDispatchPlan = useCallback(function (selectedPM, selectedCT, projectIdOverride) {
        // FIRST: Use passed parameter if explicitly provided and has id
        // if (selectedPM?.id) {
        // }
        // SECOND: Try direct from responseOneQuote.data.catalogPaymentMode.id (fallback)
        // else if (responseOneQuote?.data?.catalogPaymentMode?.id) {
        //   selectedPM = {
        //     id: responseOneQuote.data.catalogPaymentMode.id,
        //     name:
        //       responseOneQuote.data.catalogPaymentMode.description ||
        //       "From Quote Response",
        //     value:
        //       responseOneQuote.data.catalogPaymentMode.code ||
        //       responseOneQuote.data.catalogPaymentMode.id,
        //   };
        // }
        // // THIRD: Use paymentModelSelected if still null and has id
        // else if (paymentModelSelected?.id) {
        //   selectedPM = paymentModelSelected;
        // }
        // FOURTH: Use catalogPaymentMode as last fallback
        // else if (catalogPaymentMode) {
        //   selectedPM = {
        //     id: catalogPaymentMode,
        //     name: "From Quote",
        //     value: catalogPaymentMode,
        //   };
        // }
        // FALLBACK: Set to null if selectedPM was originally null
        // else if (selectedPM == null) {
        //   selectedPM = paymentModelSelected;
        // }
        // if (selectedCT == null) {
        //   selectedCT = coverTypeSelected;
        // }
        // // Check if responseOneQuote data is available before proceeding
        // if (!responseOneQuote?.data) {
        //   return;
        // }
        // if (!selectedPM?.id) {
        //   const fromPlanStep =
        //     localStorageService.getStepStored()?.steps?.[Steps.plan]
        //       ?.paymentModeSelected;
        //   if (fromPlanStep?.id) {
        //     selectedPM = fromPlanStep;
        //   }
        // }
        // if (paymentMode[0]?.id !== "-1") {
        //   if (!selectedPM?.id && responseOneQuote?.data?.catalogPaymentMode?.id) {
        //     selectedPM = {
        //       id: responseOneQuote.data.catalogPaymentMode.id,
        //       name:
        //         responseOneQuote.data.catalogPaymentMode.description ||
        //         "Final Override",
        //       value: responseOneQuote.data.catalogPaymentMode.id,
        //     };
        //   }
        //
        //   if (!selectedPM?.id) {
        //     return;
        //   }
        dispatch(plans({
            enable: enable,
            page: page,
            limit: limit,
            projectId: projectIdOverride !== null && projectIdOverride !== void 0 ? projectIdOverride : projectId,
            name: namePlan,
            paymentModeId: selectedPM === null || selectedPM === void 0 ? void 0 : selectedPM.id,
            coverTypeId: selectedCT === null || selectedCT === void 0 ? void 0 : selectedCT.id,
            clientId: clientId,
        }));
        // }
    }, [
        dispatch,
        paymentMode,
        paymentModelSelected,
        coverTypeSelected,
        projectId,
        namePlan,
        clientId,
        enable,
        page,
        limit,
        catalogPaymentMode,
        responseOneQuote,
    ]);
    // Helper function to call dispatch with automatic fallbacks
    var callDispatchPlanWithFallbacks = useCallback(function () {
        callDispatchPlan(null, null);
    }, [callDispatchPlan]);
    // Debug function to test payment mode ID extraction
    var debugPaymentModeId = useCallback(function () {
        var _a, _b;
        var directFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
        if (directFromQuote) {
            return directFromQuote;
        }
        return null;
    }, [responseOneQuote, catalogPaymentMode, paymentModelSelected, paymentMode]);
    // Function to call dispatch plan after quote data is loaded
    var callDispatchPlanAfterQuoteLoaded = useCallback(function () {
        var _a, _b;
        if ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id) {
            callDispatchPlan(null, null);
        }
        else {
            debugPaymentModeId();
        }
    }, [responseOneQuote, callDispatchPlan, debugPaymentModeId]);
    var handleSearch = useCallback(function (value, isInsuranceFlag, setIsInsurance, setDocument, setTrigger) {
        var document = value.target.value;
        if (document) {
            var cleanedDocument = document.replace(/-/g, "");
            var numberDocument = Number(cleanedDocument);
            if (!isNaN(numberDocument)) {
                setIsInsurance(isInsuranceFlag);
                setDocument(numberDocument);
                setTrigger(true);
            }
        }
    }, []);
    var searchPerson = useCallback(function (value, setIsInsurance, setDocument, setTrigger) {
        handleSearch(value, false, setIsInsurance, setDocument, setTrigger);
    }, [handleSearch]);
    var handleOnChangePaymentMethod = useCallback(function (event) {
        var paymentPeriod = paymentMode.find(function (x) { return x.value === event; });
        setPeriod(paymentPeriod === null || paymentPeriod === void 0 ? void 0 : paymentPeriod.name);
        setPaymentModelSelected(paymentPeriod);
        var pm = paymentMode.map(function (item) { return (__assign(__assign({}, item), { default: item.id === (paymentPeriod === null || paymentPeriod === void 0 ? void 0 : paymentPeriod.id) })); });
        setPaymentMode(pm);
        callDispatchPlan(paymentPeriod, null);
    }, [
        callDispatchPlan,
        paymentMode,
        setPeriod,
        setPaymentModelSelected,
        setPaymentMode,
    ]);
    var handleOnChangeCoverType = useCallback(function (event) {
        setCoverTypeSelected(event);
        callDispatchPlan(paymentModelSelected, event);
    }, [callDispatchPlan, paymentModelSelected]);
    var handleOnChangeCampaign = useCallback(function (event) {
        var campaignS = campaigns.find(function (x) { return x.id === event; });
        setCampaignSelected(campaignS);
    }, [campaigns]);
    var handleChangeProvince = useCallback(function (id) {
        dispatch(region({
            enable: enable,
            page: page,
            limit: limit,
            level: level2,
            parentRegionId: id,
        }));
        setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
    }, [dispatch]);
    var handleChangeTown = useCallback(function (id) {
        dispatch(region({
            enable: enable,
            page: page,
            limit: limit,
            level: level3,
            parentRegionId: id,
        }));
    }, [dispatch]);
    var getPaymentStatus = function (status) {
        switch (status) {
            case "PENDING":
                return t("confirmationData.paymentStatuses.PENDING");
            case "READY":
                return t("confirmationData.paymentStatuses.READY");
            default:
                return "";
        }
    };
    var getBillingStatus = function (status) {
        switch (status) {
            case "GENERATED":
                return t("confirmationData.paymentStatuses.GENERATED");
            case "EMMITED":
                return t("confirmationData.paymentStatuses.EMMITED");
            case "PAID":
                return t("confirmationData.paymentStatuses.PAID");
            case "CANCELLED":
                return t("confirmationData.paymentStatuses.CANCELLED");
            default:
                return "";
        }
    };
    var handleChangeSelect = useCallback(function (event) {
        var _a = event.target, value = _a.value, name = _a.name;
        if (name === "ProvinceName") {
            handleChangeProvince(value);
            setDataForm(function (prev) { return (__assign(__assign({}, prev), { Province: value, Town: "", Sector: "" })); });
        }
        else if (name === "TownName") {
            handleChangeTown(value);
            setDataForm(function (prev) { return (__assign(__assign({}, prev), { Town: value, Sector: "" })); });
        }
        else if (name === "SectorName") {
            setDataForm(function (prev) { return (__assign(__assign({}, prev), { Sector: value })); });
        }
        else if (name === "CountryName") {
            setDataForm(function (prev) { return (__assign(__assign({}, prev), { Country: value })); });
        }
        var gender = listGenders.find(function (g) { return g.id === value; });
        setHideMarriedName((gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true);
    }, [handleChangeProvince, handleChangeTown, setDataForm]);
    var handleChangeSelectFormInsurance = useCallback(function (event, id) {
        var value = event.value;
        var name = id;
        if (name === "Province" || name === "province")
            handleChangeProvince(value);
        else if (name === "Town" || name === "town")
            handleChangeTown(value);
        // Solo actualizar hideMarriedName si el campo es Gender
        if (name === "Gender" || name === "gender") {
            setHideMarriedName(event.name !== "Femenino");
        }
    }, [handleChangeProvince, handleChangeTown]);
    var handleDownload = useCallback(function (obj) {
        window.open(obj.url, "_blank");
    }, []);
    var handleUpdatePerson = useCallback(function (dataForm) {
        var body = {
            clientId: clientId,
            identificationTypeId: dataForm.IdType,
            countryId: dataForm.Country,
            catalogGender: dataForm.Gender,
            catalogTitle: "3536c66a-2cf7-44b1-9a81-b7486902b997",
            catalogRegionLevel1: dataForm.Province,
            catalogRegionLevel2: dataForm.Town,
            catalogRegionLevel3: dataForm.Sector,
            catalogCivilStatus: "42bedbc9-91cf-4d40-818e-3fc643e13e51",
            catalogProfession: "811c8769-9e83-42a3-9381-0ae279faf525",
            numberId: dataForm.DocumentNumber,
            firstNameA: dataForm.Name,
            firstNameB: dataForm.SecondName,
            lastNameA: dataForm.FirstLastName,
            lastNameB: dataForm.SecondLastName,
            addressA: dataForm.Address1,
            addressB: dataForm.Address2,
            zip: dataForm.PostalCode,
            phone1: removeNonNumeric(dataForm.PhoneHome),
            phone2: removeNonNumeric(dataForm.PhoneOffice),
            phone3: removeNonNumeric(dataForm.PhoneNumber),
            email: dataForm.Email,
            marriedName: hideMarriedName ? "" : dataForm.MarriedSurName,
            dob: formattedDateWithTime(dataForm.Birthday),
        };
        dispatch(updatePerson({ body: body, id: personQuoteId }));
    }, [dispatch, personQuoteId, hideMarriedName, clientId]);
    var setLocalStorage = useCallback(function (project) {
        var campaignData = project === null || project === void 0 ? void 0 : project.campaign.map(function (p) { return ({
            id: p.id,
            name: p.name,
            value: p.id,
        }); });
        setCampaign(campaignData);
        setCampaigns(campaignData);
    }, []);
    var updateDataFormPerson = useCallback(function (dataPerson, currentDataForm) { return (__assign(__assign({}, currentDataForm), { Id: dataPerson.id, IdType: dataPerson.identificationTypeId, DocumentNumber: dataPerson.numberId, Name: dataPerson.firstNameA, SecondName: dataPerson.firstNameB, LastNameA: dataPerson.lastNameA, LastNameB: dataPerson.lastNameB, marriedName: dataPerson.marriedName, Birthday: dataPerson.dob, PhoneNumber: dataPerson.phone1 })); }, []);
    var setCoverTypeStorybook = useCallback(function (ct, selectedId) {
        var mapped = ct.map(function (item) { return ({
            name: item.description || "",
            value: item.id,
            id: item.id,
            default: selectedId ? item.id === selectedId : false,
        }); });
        if (selectedId) {
            mapped.sort(function (a, b) {
                if (a.id === selectedId)
                    return -1;
                if (b.id === selectedId)
                    return 1;
                return 0;
            });
        }
        return mapped;
    }, []);
    var handleOnClickAcquire = useCallback(function (item) {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h;
        var ct = coverTypeSelected || item.option[0];
        // Update all related states
        setCoverType(ct);
        setPlan({ id: item.id, name: item.name });
        // Update payment mode if available in item
        if (item.paymentMethod) {
            setPaymentModelSelected(item.paymentMethod);
            setPeriod((_b = item.paymentMethod) === null || _b === void 0 ? void 0 : _b.name);
            // Update payment mode array to mark selected as default
            var updatedPaymentMode = paymentMode.map(function (pm) {
                var _a;
                return (__assign(__assign({}, pm), { default: pm.id === ((_a = item.paymentMethod) === null || _a === void 0 ? void 0 : _a.id) }));
            });
            setPaymentMode(updatedPaymentMode);
        }
        // Update dataForm with new plan name
        setDataForm(function (prevDataForm) { return (__assign(__assign({}, prevDataForm), { PlanTypeName: item.name || "" })); });
        // Update prime (price)
        if (item.price) {
            setPrime(item.price);
        }
        // Update defaultFilters with new plan information
        setDefaultFilters(function (prevFilters) {
            return prevFilters.map(function (filter) {
                if (filter.name === "Plan") {
                    return __assign(__assign({}, filter), { label: item.name || "" });
                }
                if (filter.name === "Prima" && item.price) {
                    return __assign(__assign({}, filter), { label: "".concat(item.currency || "RD$", " ").concat(item.price) });
                }
                if (filter.name === "Modalidad de Pago" && item.paymentMethod) {
                    return __assign(__assign({}, filter), { label: item.paymentMethod.name || "" });
                }
                if (filter.name === "Tipo de Cobertura" && ct) {
                    return __assign(__assign({}, filter), { label: ct.name || "" });
                }
                return filter;
            });
        });
        // Update localStorage for summary/filters
        var currentSteps = localStorageService.getStepStored() || {};
        var updatedSteps = __assign(__assign({}, currentSteps), { steps: __assign(__assign({}, currentSteps.steps), (_a = {}, _a[Steps.customer] = __assign(__assign({}, (((_c = currentSteps.steps) === null || _c === void 0 ? void 0 : _c[Steps.customer]) || {})), { id: item.id, name: item.name, planSelected: { id: item.id, name: item.name }, paymentModeSelected: item.paymentMethod, coverType: ct, planPrice: item.price, planCurrency: item.currency }), _a)) });
        //localStorageService.setStepStored(updatedSteps);
        // Derive the active payment mode from the dropdown array (always has correct
        // default flag regardless of state timing) rather than from potentially
        // stale paymentModelSelected state or item.paymentMethod snapshot.
        var activePaymentMode = paymentMode.find(function (pm) { return pm.default; }) ||
            item.paymentMethod ||
            paymentModelSelected;
        // Call plan API with updated parameters
        callDispatchPlan(activePaymentMode, ct);
        // Persist the selection by calling PATCH /V1/Quote/{id}.
        // The backend UpdateQuoteDto requires all ids, so we merge the new
        // selections on top of the current quote data.
        var currentQuote = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
        if (quoteId && currentQuote) {
            var planIdBody = item.id || ((_d = currentQuote.planId) === null || _d === void 0 ? void 0 : _d.id);
            var coverTypeIdBody = (ct === null || ct === void 0 ? void 0 : ct.id) || (ct === null || ct === void 0 ? void 0 : ct.value) || ((_e = currentQuote.coverType) === null || _e === void 0 ? void 0 : _e.id);
            var campaignIdBody = (campaignSelected === null || campaignSelected === void 0 ? void 0 : campaignSelected.id) || ((_f = currentQuote.campaignId) === null || _f === void 0 ? void 0 : _f.id);
            var catalogPaymentModeBody = (activePaymentMode === null || activePaymentMode === void 0 ? void 0 : activePaymentMode.id) ||
                ((_g = currentQuote.catalogPaymentMode) === null || _g === void 0 ? void 0 : _g.id);
            var branchIdBody = currentQuote.branch;
            var catalogStatusQuoteBody = (_h = currentQuote.catalogStatusQuote) === null || _h === void 0 ? void 0 : _h.id;
            if (planIdBody &&
                coverTypeIdBody &&
                campaignIdBody &&
                catalogPaymentModeBody &&
                branchIdBody &&
                catalogStatusQuoteBody &&
                userId) {
                var body = {
                    planId: planIdBody,
                    coverTypeId: coverTypeIdBody,
                    campaignId: campaignIdBody,
                    catalogPaymentMode: catalogPaymentModeBody,
                    catalogStatusQuote: catalogStatusQuoteBody,
                    branchId: branchIdBody,
                    userId: userId,
                };
                dispatch(patchQuote({ body: body }, quoteId));
            }
        }
    }, [
        callDispatchPlan,
        coverTypeSelected,
        paymentMode,
        setPaymentModelSelected,
        setPeriod,
        setPaymentMode,
        localStorageService,
        setDataForm,
        setDefaultFilters,
        setPrime,
        responseOneQuote,
        campaignSelected,
        paymentModelSelected,
        quoteId,
        userId,
        dispatch,
    ]);
    var quoteUploadDocuments = useCallback(function (file) {
        if (file) {
            setFileName(file[0].name.replace(".pdf", ""));
            setPdfFile(file[0]);
            setUploadTrigger(true);
        }
    }, []);
    var callQuoteOne = useCallback(function (quoteId) {
        if (quoteId !== "") {
            dispatch(quoteOne({
                id: quoteId,
                fullBody: true,
            }));
        }
    }, [dispatch]);
    var callDispatchPageActionFlags = useCallback(function (id) {
        dispatch(pageActionFlagsApi({
            enable: enable,
            page: page,
            limit: limit,
            clientId: clientId,
            projectId: id,
        }));
    }, [dispatch, enable, page, limit, clientId]);
    var getActionFlags = useCallback(function () {
        if (actionFlags && actionFlags.length > 0) {
            var rfShowInsured = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-show-insured");
            var rfShowVehicle = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-show-vehicle");
            var rfAddInsurance = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-add-insured");
            var rfShowBeneficiary = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-add-beneficiary");
            var rfShowDownloadQuote = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-show-button-download-quote");
            var rfShowDownloadRequest = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-show-button-download-request");
            var rfViewNewFormInsurance = ReadFlags(actionFlags ? actionFlags : [], "afy-view-new-form-add-insurance");
            var rfViewTabRealEstates = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-show-tab-real-estates");
            var rfShowFormAddBusiness = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-show-form-add-business");
            var rfActivePolicy = ReadFlags(actionFlags ? actionFlags : [], "afy-activate-policy");
            var rfViewTabAppointment = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-show-tab-appointment");
            var rfViewTabAppointmentManager = ReadFlags(actionFlags ? actionFlags : [], "afy-confirm-data-show-tab-appointment-manager");
            setShowInsured(!(rfShowInsured === "true"));
            setShowVehicleData(!(rfShowVehicle === "true"));
            setShowBeneficiary(!(rfShowBeneficiary === "true"));
            setShowDownloadQuote(!(rfShowDownloadQuote === "true"));
            setShowDownloadRequest(!(rfShowDownloadRequest === "true"));
            setShowNewFormInsurance(!(rfViewNewFormInsurance === "true"));
            setShowTabRealEstates(!(rfViewTabRealEstates === "true"));
            setShowFormBusiness(rfShowFormAddBusiness === "true");
            setShowTabAppointment(rfViewTabAppointment === "true");
            setShowTabAppointmentManager(rfViewTabAppointment === "true");
            // hideAddButton[n]: true = hide "+ Agregar". Driven by PageActionFlags API
            setAddInsured(rfAddInsurance !== "true");
            setAddBeneficiary(rfShowBeneficiary !== "true");
        }
        else {
            // No flags yet (or empty payload): keep "+ Agregar" hidden until GET PageActionFlags resolves.
            setAddInsured(true);
            setAddBeneficiary(true);
        }
        // Grid Editar/Eliminar: not gated on isQuote — same UX for cotización and emitida (PageActionFlags can be added later if needed).
        setCanEditInsured(true);
        setCanEditBeneficiary(true);
    }, [
        actionFlags,
        setShowInsured,
        setShowVehicleData,
        setShowBeneficiary,
        setShowDownloadQuote,
        setShowDownloadRequest,
        setShowNewFormInsurance,
        setAddInsured,
        setAddBeneficiary,
        setCanEditInsured,
        setCanEditBeneficiary,
    ]);
    var handleOnClickAutoDownload = useCallback(function () {
        // LLAMA AL API DE COTIZACION
        setTriggerCertificate(true);
        //callDispatchPlan();
    }, [setTriggerCertificate]);
    var handleOnClickAutoDownloadVida = useCallback(function (data) {
        var _a;
        // LLAMA
        var certs = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.certificates;
        var cert = certs.find(function (cert) {
            var _a;
            return ((_a = cert.certificateDocumentInfo) === null || _a === void 0 ? void 0 : _a.physicalName) ===
                "suscripcion_individual_vida_termino.docx";
        });
        var urlC = cert === null || cert === void 0 ? void 0 : cert.url;
        if (urlC) {
            setUrlDocument(urlC);
            setopenModalPdfViewer(true);
        }
    }, [responseOneQuote, setUrlDocument, setopenModalPdfViewer]);
    return useMemo(function () { return ({
        searchPerson: searchPerson,
        handleSearch: handleSearch,
        callDispatchPlan: callDispatchPlan,
        callDispatchPlanWithFallbacks: callDispatchPlanWithFallbacks,
        callDispatchPlanAfterQuoteLoaded: callDispatchPlanAfterQuoteLoaded,
        debugPaymentModeId: debugPaymentModeId,
        handleOnChangePaymentMethod: handleOnChangePaymentMethod,
        handleOnChangeCoverType: handleOnChangeCoverType,
        handleOnChangeCampaign: handleOnChangeCampaign,
        handleChangeSelect: handleChangeSelect,
        handleUpdatePerson: handleUpdatePerson,
        handleDownload: handleDownload,
        setLocalStorage: setLocalStorage,
        updateDataFormPerson: updateDataFormPerson,
        setCoverTypeStorybook: setCoverTypeStorybook,
        handleOnClickAcquire: handleOnClickAcquire,
        quoteUploadDocuments: quoteUploadDocuments,
        callQuoteOne: callQuoteOne,
        callDispatchPageActionFlags: callDispatchPageActionFlags,
        getActionFlags: getActionFlags,
        handleOnClickAutoDownload: handleOnClickAutoDownload,
        handleOnClickAutoDownloadVida: handleOnClickAutoDownloadVida,
        getPaymentStatus: getPaymentStatus,
        getBillingStatus: getBillingStatus,
        showVehicleData: showVehicleData,
        showDownloadQuote: showDownloadQuote,
        showDownloadRequest: showDownloadRequest,
        handleChangeSelectFormInsurance: handleChangeSelectFormInsurance,
    }); }, [
        searchPerson,
        handleSearch,
        callDispatchPlan,
        handleOnChangePaymentMethod,
        handleOnChangeCoverType,
        handleOnChangeCampaign,
        handleChangeSelect,
        handleUpdatePerson,
        handleDownload,
        setLocalStorage,
        updateDataFormPerson,
        setCoverTypeStorybook,
        handleOnClickAcquire,
        quoteUploadDocuments,
        callQuoteOne,
        callDispatchPageActionFlags,
        getActionFlags,
        handleOnClickAutoDownload,
        handleOnClickAutoDownloadVida,
        getPaymentStatus,
        getBillingStatus,
        showVehicleData,
        handleChangeSelectFormInsurance,
    ]);
};
export default useClient;
